import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import moment from 'moment';
import { Alert, Spinner } from "react-bootstrap";
import BooksRequestList from './BooksRequestList.jsx';
import BookRequestTable from '../BookRequestTable/BookRequestTable';
import BookRequestFilter from '../BookRequestTable/BookRequestFilter'
import CreateNewForm from '../NewBookRequest/CreateNewForm';
import { createNotification } from '../notifications/notifications';


const mapStateToProps = ({ form }) => ({
  timeValues: form.bookRequestFilterSelection
});

class BooksRequest extends Component {
  state = {
    isModalVisible: false,
    isNewRequest: false,
    isLoading: true,
    creationModal: false,
    isDataModalOpen: false,
  };

  componentDidMount() {
    setTimeout(this.selectBookOrdersByDates, 100);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.booksRequest.bookOrdersList.length && this.setState({ isLoading: false });
  }

  fetchBookOrders = (dates) => {
    const { fetchBookOrders } = this.props;
    fetchBookOrders(dates)
      .then(() => this.setState({ isLoading: false }));
  }

  bookRequestById = (id) => {
    const { bookRequestById } = this.props;
    bookRequestById(id);
  }

  addBooksRequest = (formData) => {
    const { addRequest } = this.props;
    const dataset = {
      "curriculum_course_id": formData.curriculum_course_id,
      "curriculum_course_name": formData.curriculum_course_name
    };
    addRequest(dataset)
      .then(() => {
      this.handleCreationModal(false);
      this.handleToggleModal(true, this.props.booksRequest.addNewOrderData.id);
    })
  }

  deleteRequestById = (id) => {
    const { deleteRequestId } = this.props;
    const confirmDelete = window.confirm(`Вы действительно хотите удалить этот заказ?`);

    if(confirmDelete) {
      deleteRequestId(id);
      this.handleToggleModal(false)();
      this.componentDidMount();
      createNotification('success', 'Заказ успено удален');
    }
  }

  handleToggleModal = (isModalVisible, id) => {
    if(!isModalVisible) {
      this.selectBookOrdersByDates();
    }
    this.setState({isNewRequest: false});
    this.bookRequestById(id);
    this.setState({isModalVisible});
  }

  handleCreationModal = (modalVisible) => {
    this.setState({creationModal: modalVisible});
  };

  handleSubmit = (values) => {
    this.selectBookOrdersByDates();
  };

  selectBookOrdersByDates = (event) => {
    if (event) {
      event.preventDefault();
    }
    let from = moment(this.props.timeValues.values.selectFrom).format("YYYY-MM-DD");
    let to = moment(this.props.timeValues.values.selectTo).format("YYYY-MM-DD");
    if (from > to) {
      return this.setState({ isDataModalOpen: true })
    }
    let dates = [from, to];
    this.fetchBookOrders(dates);
    this.setState({ isDataModalOpen: false });
  }

  render() {
    const {
      booksRequest,
      searchBooks,
      addBooksToOrder,
      removeBooksFromOrder,
      bookRequestById,
      editBooksFromOrder
    } = this.props;

    const {
      isModalVisible,
      isLoading,
      creationModal
    } = this.state;
    let modalData = booksRequest.modalWindow.data;
    return (
      <div>
        <div className="captions">Заказ литературы</div>
        <div className="booksRequest__table">
          <Modal
            isOpen={creationModal}
            className="StudentProjectSmallModal"
            onRequestClose={() => this.handleCreationModal(false)}
            contentLabel="Modal"
          >
            <CreateNewForm modalHandler={this.handleCreationModal} submitHandler={this.addBooksRequest}/>
          </Modal>
          <Modal
            isOpen={isModalVisible}
            onRequestClose={() => this.handleToggleModal(false)}
            contentLabel="Modal"
          >
            <div className="PR-StudProjModal">
              <div className="PR-StudProjModal__header">
                <div>
                  <p>
                    <span>Дата создания:</span>
                    {moment(modalData.creationtime).format('DD.MM.YYYY')}
                  </p>
                  <p>
                    <span>Дисциплина / учебный курс:</span>
                    {modalData.curriculum_course_name}
                  </p>
                  <p>
                    <span>Имя заявителя:</span>
                    {modalData.creatorname}
                  </p>

                  <BooksRequestList
                    bookRequestById={bookRequestById}
                    searchBooks={searchBooks}
                    modalData={modalData}
                    addBooks={addBooksToOrder}
                    requestId={modalData.id}
                    deleteBooks={removeBooksFromOrder}
                    editOrder={editBooksFromOrder}
                  />
                </div>
                <div className="PR-StudProjModalFooter">
                  <div>
                    <button onClick={this.deleteRequestById.bind(this, modalData.id)}>Удалить заказ</button>
                    <button onClick={() => this.handleToggleModal(false)}>Закрыть</button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <BookRequestFilter formName='Selection' onSubmit={this.handleSubmit}/>
            <button className="btn" onClick={this.handleCreationModal}>Добавить новый</button>
          </div>
          {isLoading ?  (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <div>
              {booksRequest.bookOrdersList.length ? (
                <BookRequestTable data={booksRequest.bookOrdersList} modalHandler={this.handleToggleModal} />
              ) : (
                <Alert variant="danger">
                  <Alert.Heading>Ничего не найдено</Alert.Heading>
                </Alert>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(BooksRequest);
